import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'keys'
})
export class KeysPipe implements PipeTransform {
    transform(obj: any): any[] {

        return Object.keys(obj).map(k => {
            return { key: k, value: obj[k] }
        })
    }
}

@Pipe({
    name: 'initials'
})
export class InitialsPipe implements PipeTransform {
    transform(displayName: string): string {
        let names = displayName.split(' ');
        let initials = names[0][0];
        if(names.length > 1) initials += names[names.length - 1][0];
        return initials.toUpperCase();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/keys.pipe.ts